export const downsellRedirectOptions = [
  { value: '1', label: 'Thanks' },
  { value: '2', label: 'Offerwall' },
]

export const chatRedirectOptions = [
  { value: '1', label: 'Chat' },
  { value: '2', label: 'Chat Now' },
  { value: '3', label: 'NDR' },
  { value: '4', label: 'TD-NDR' },
  { value: '5', label: 'Brandless' },
  { value: '6', label: 'AI Chat' },
]
